import { createRootRouteWithContext, isRedirect, Outlet, useRouter } from "@tanstack/react-router";
import * as stylex from "@stylexjs/stylex";
import Button from "@/components/ui/Button";
import CenteredCard from "@/components/ui/CenteredCard";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";
import { isStaleBuildError, useReloadForNewBuild } from "@/lib/stale-build";
import type { RouterContext } from "@/router-context";
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: RootErrorComponent
});
function RootComponent() {
  // Keep the application surface identical in development and production.
  // The floating Router Devtools trigger covered bottom-right actions in
  // Review Studio at common laptop and phone sizes, making real E2E clicks hit
  // the developer overlay instead of the product UI.
  return <Outlet />;
}
function RootErrorComponent({
  error
}: {
  error: unknown;
}) {
  const router = useRouter();
  // A tab from before a deploy reloads into the new build instead of failing.
  const reloading = useReloadForNewBuild(error);
  if (isRedirect(error) || reloading) {
    return null;
  }
  const message = error instanceof Error ? error.message : "Something went wrong.";
  return <CenteredCard role="alert">
      <h1 className="x1ghz6dp xuxpmqx xk50ysn xgwkh9f">This page didn’t load</h1>
      <p className="x1ghz6dp xtu3avg x1evy7pa x1e3avs9 xj0a0fe">{message}</p>
      <div className="x78zum5 x13a6bvl x166cprz x11j7w4t">
        <Button variant="ghost" onClick={() => window.location.assign("/")}>
          Go home
        </Button>
        <Button variant="primary" onClick={() =>
      // A failed chunk stays failed until the page loads the new build.
      isStaleBuildError(error) ? window.location.reload() : void router.invalidate()}>
          Retry
        </Button>
      </div>
    </CenteredCard>;
}